const CHECKBOX_KEYS = {
    SPACE: " ",
};
const ARIA_CHECKED = {
    TRUE: true,
    FALSE: false,
    MIXED: "mixed",
};
const CHECKBOX_STATES = {
    CHECKED: "checked",
    UNCHECKED: "unchecked",
    DISABLED: "disabled",
    MIXED: "mixed",
};

export { ARIA_CHECKED, CHECKBOX_KEYS, CHECKBOX_STATES };
